// src/pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] text-center p-6 mt-24">
      <h1 className="text-6xl font-extrabold text-red-600">404</h1>
      <p className="mt-4 text-xl font-medium text-gray-700">
        Oops! Page not found.
      </p>
      <p className="mt-2 text-gray-500">
        The page you are looking for might have been removed or never existed.
      </p>
    </div>
  );
};

export default NotFound;
